import React, { useContext, useEffect } from 'react'
import { SideberContext } from '../context/SidebarContext'
import { IoHomeSharp } from "react-icons/io5";
import { BiSolidRadio } from "react-icons/bi";
import { IoCalendarNumber } from "react-icons/io5";
import { BiSolidMegaphone } from "react-icons/bi";
import { BsCalendar2CheckFill } from "react-icons/bs";
import { MdOutlineKeyboardArrowLeft } from "react-icons/md";
import { NavLink, useLocation } from 'react-router-dom';
import { NavbarContext } from '../context/NavbarContext';
import { GrGallery } from "react-icons/gr";
import { RiTeamFill } from "react-icons/ri";
import { MdPodcasts } from "react-icons/md";

function Sidebar() {
    const { mySidebar, setMySidebar } = useContext(SideberContext)
    const { navHeading, setNavHeading } = useContext(NavbarContext)
    const location = useLocation();
    /*
        useEffect(() => {
            if (location.pathname === "/") {
                setNavHeading("My Radio App");
            } else if (location.pathname === "/podcast") {
                setNavHeading("Podcast");
            } else if (location.pathname === "/schedule") {
                setNavHeading("Schedule");
            } else if (location.pathname === "/news") {
                setNavHeading("News");
            } else if (location.pathname === "/events") {
                setNavHeading("Events");
            } else if (location.pathname === "/myevents") {
                setNavHeading("Events");
            }else if (location.pathname === "/albums") {
                setNavHeading("Albums");
            }
        }, [location.pathname]);
        */
    useEffect(() => {
        // console.log(mySidebar);

    }, [mySidebar])

    return (
        <>
            <div className={mySidebar ? "My-sidebar-main-unvisible-div-active" : "My-sidebar-main-unvisible-div-unactive"} onClick={() => setMySidebar(false)}>
                <div className={mySidebar ? 'sidebar-main-active' : 'sidebar-main'} onClick={(e) => e.stopPropagation()}>
                    <div className='sidebar-logo'><MdOutlineKeyboardArrowLeft style={{ cursor: "pointer" }} className='sidebar-arrow' onClick={() => setMySidebar(false)} /></div>
                    <div className='sidebar-options'>
                        <NavLink to="/" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'><IoHomeSharp /><p>Home</p></div></NavLink>
                        <NavLink to="/podcast" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'>
                            {/* <BiSolidRadio /> */}
                            <MdPodcasts />
                            <p>Podcast</p></div></NavLink>
                        <NavLink id="interviews-for-laptop0988" to="/interviews" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'><RiTeamFill /><p>Interviews</p></div></NavLink>
                        <NavLink to="/schedule" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'><IoCalendarNumber /><p>Schedule</p></div></NavLink>
                        <NavLink id="gallery-for-laptop0977" to="/albums" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'><GrGallery /><p>Gallery</p></div></NavLink>
                        <NavLink to="/news" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'><BiSolidMegaphone /><p>News</p></div></NavLink>
                        <NavLink id="event-for-phone0977" to="/events" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'><BsCalendar2CheckFill /><p>Events</p></div></NavLink>
                        <NavLink id="liveTv-for-phone0977" to="/videoplayer" className={(navData) => navData.isActive ? "my-nav-link" : "sidebar-my-option"}><div className='sidebar-my-option-inner-div'><BsCalendar2CheckFill /><p>Live TV</p></div></NavLink>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Sidebar